import { Component } from '@angular/core';
import dayjs from 'dayjs';

@Component({
  standalone: true,
  selector: 'app-footer',
  template: ` <div class="layout-footer flex flex-col sm:flex-row items-center justify-center py-4 gap-2">
    <span class="font-medium text-gray-500">Copyright © Dr. Got Home Clinic {{ year }}</span>
  </div>`
})
export class AppFooter {
  year = dayjs().year();
}
